import React from 'react';
import {injectIntl} from 'react-intl';

const Salary = ({intl, data}) => {
  return (
    <div className="wrapper py-l l:py-xl">
      <div className="l:w-3/4 l:flex justify-between">
        <div className="flex flex-1 flex-col">
          <div className="body--m l:text-title-s">{intl.formatMessage({id: 'Salary.Low.Label'})}</div>
          <div className="divider my-s hidden--until-l" aria-hidden="true"></div>
          <div className="title--xs l:text-title-s">{data.salary.low}</div>
          <div className="divider my-s hidden--until-l" aria-hidden="true"></div>
        </div>
        <div className="divider my-s hidden--from-l" aria-hidden="true"></div>
        <div className="text--emphasis flex  flex-1 flex-col">
          <div className="body--m l:text-title-s">{intl.formatMessage({id: 'Salary.Average.Label'})}</div>
          <div className="divider my-s hidden--until-l" aria-hidden="true"></div>
          <div className="title--xs l:text-title-s">{data.salary.average}</div>
          <div className="divider my-s hidden--until-l" aria-hidden="true"></div>
        </div>
        <div className="divider my-s hidden--from-l" aria-hidden="true"></div>
        <div className="flex flex-1 flex-col">
          <div className="body--m l:text-title-s">{intl.formatMessage({id: 'Salary.High.Label'})}</div>
          <div className="divider my-s hidden--until-l" aria-hidden="true"></div>
          <div className="title--xs l:text-title-s" aria-hidden="true">{data.salary.high}</div>
          <div className="divider my-s hidden--until-l" aria-hidden="true"></div>
        </div>
        <div className="divider my-s hidden--from-l" aria-hidden="true"></div>
      </div>

      <h2 className="title--s text--emphasis pt-xs pb-s l:my-m">{data.header}</h2>
      <div>{data.description}</div>

    </div>
  );
};

export default injectIntl(Salary);
